var _style, _path, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpacity = function SvgOpacity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "opacity_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M12 2.53c3.55 2.95 5.95 6.69 6.77 8.07l.33.59c.6 1.06.9 2.21.9 3.41 0 4.08-3.59 7.4-8 7.4s-8-3.32-8-7.4c0-1.2.3-2.34.9-3.41l.34-.6C6.06 9.2 8.45 5.49 12 2.53M12 0C6.42 4.05 3.16 10.21 3.16 10.21A8.879 8.879 0 0 0 2 14.6C2 19.79 6.48 24 12 24s10-4.21 10-9.4c0-1.59-.42-3.08-1.16-4.39 0 0-3.27-6.16-8.84-10.21z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "opacity_svg__SVGID_1_",
    d: "M3.97 14.64c0 4.08 3.59 7.4 8 7.4s9-3.92 9-8c0-.45-1.06-.3-1.15-.74H4.11c-.08.44-.14.89-.14 1.34z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "opacity_svg__SVGID_00000159429362124224205720000000661723249979506318_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#opacity_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#opacity_svg__SVGID_00000159429362124224205720000000661723249979506318_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M-2.03 13.04h2.5v2.5h-2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M2.76 13.25v2.08H.68v-2.08h2.08m.21-.21H.47v2.5h2.5v-2.5zM2.97 13.04h2.5v2.5h-2.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M7.76 13.25v2.08H5.68v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M7.97 13.04h2.5v2.5h-2.5zM12.76 13.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM.26 15.75v2.08h-2.08v-2.08H.26m.21-.21h-2.5v2.5h2.5v-2.5zM.47 15.54h2.5v2.5H.47zM5.26 15.75v2.08H3.18v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM5.47 15.54h2.5v2.5h-2.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M10.26 15.75v2.08H8.18v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM10.47 15.54h2.5v2.5h-2.5zM-2.03 18.04h2.5v2.5h-2.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M2.76 18.25v2.08H.68v-2.08h2.08m.21-.21H.47v2.5h2.5v-2.5zM2.97 18.04h2.5v2.5h-2.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M7.76 18.25v2.08H5.68v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M7.97 18.04h2.5v2.5h-2.5zM12.76 18.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM.26 20.75v2.08h-2.08v-2.08H.26m.21-.21h-2.5v2.5h2.5v-2.5zM.47 20.54h2.5v2.5H.47zM5.26 20.75v2.08H3.18v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM5.47 20.54h2.5v2.5h-2.5zM10.26 20.75v2.08H8.18v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM10.47 20.54h2.5v2.5h-2.5zM12.97 13.04h2.5v2.5h-2.5zM17.76 13.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M17.97 13.04h2.5v2.5h-2.5zM22.76 13.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM22.97 13.04h2.5v2.5h-2.5zM27.76 13.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM15.26 15.75v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M15.47 15.54h2.5v2.5h-2.5zM20.26 15.75v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM20.47 15.54h2.5v2.5h-2.5zM25.26 15.75v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM25.47 15.54h2.5v2.5h-2.5zM12.97 18.04h2.5v2.5h-2.5zM17.76 18.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M17.97 18.04h2.5v2.5h-2.5zM22.76 18.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM22.97 18.04h2.5v2.5h-2.5zM27.76 18.25v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM15.26 20.75v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "opacity_svg__st0",
    d: "M15.47 20.54h2.5v2.5h-2.5zM20.26 20.75v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM20.47 20.54h2.5v2.5h-2.5zM25.26 20.75v2.08h-2.08v-2.08h2.08m.21-.21h-2.5v2.5h2.5v-2.5zM25.47 20.54h2.5v2.5h-2.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    d: "M3.97 13.04h16"
  }));
};
export default SvgOpacity;